export default __webpack_public_path__ + "4fc68baf6b1bbf6ec66be3e2123edc2a.svg";